import { createAction } from '@reduxjs/toolkit';

export const CONNECT_SOCKET_TYPE = 'saga/connectSocket';
export const connectSocketAction = createAction(CONNECT_SOCKET_TYPE);
